export enum gregorio_note_iter_item_type {
  GRESTRUCT_NONE = 0,
  GRESTRUCT_NOTE = 1 << 0,
  GRESTRUCT_GLYPH = 1 << 1,
  GRESTRUCT_ELEMENT = 1 << 2,
  GRESTRUCT_SYLLABLE = 1 << 3
}
